import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import Loadable from './_shared/MyLoadable'
import LoadingOverlay from 'react-loading-overlay'
import '../css/app.css'

import config from '../utils/config'

import Footer from './Footer'
import Header from './Header'

import cookie from 'react-cookies'

const LoadableConfirmEmailBanner = Loadable({ loader: () => import('./ConfirmEmailBanner') })
const LoadableEasymillionsLoginTab = Loadable({ loader: () => import('./EasymillionsLoginTab') })
const LoadableConfirmCustomer = Loadable({ loader: () => import('./ConfirmCustomer') })
const LoadablePageNotFound = Loadable({ loader: () => import('./PageNotFound') })
const LoadableConfirmLead = Loadable({ loader: () => import('./ConfirmLead') })
const LoadableCategory = Loadable({ loader: () => import('./Category') })
const LoadableProfile = Loadable({ loader: () => import('./Profile') })
const LoadableContact = Loadable({ loader: () => import('./Contact') })
const LoadablePayoff = Loadable({ loader: () => import('./Payoff') })
const LoadableSearch = Loadable({ loader: () => import('./Search') })
const LoadableWallet = Loadable({ loader: () => import('./Wallet') })
const LoadableError = Loadable({ loader: () => import('./Error'), loading: () => null })
const LoadableLogin = Loadable({ loader: () => import('./Login') })
const LoadableRegistration = Loadable({ loader: () => import('./Registration') })
const LoadableHome = Loadable({ loader: () => import('./Home') })
const LoadablePage = Loadable({ loader: () => import('./Page') })
const LoadableFAQ = Loadable({ loader: () => import('./FAQ') })
const LoadablePasswordRecover = Loadable({ loader: () => import('./PasswordRecover') })
const LoadableChangePassword = Loadable({ loader: () => import('./ChangePassword') })
const LoadableReactivate = Loadable({ loader: () => import('./Reactivate') })
const LoadableChangeEmail = Loadable({ loader: () => import('./ChangeEmail') })
const LoadableUnsubscribeEmail = Loadable({ loader: () => import('./UnsubscribeEmail') })
const LoadableLandingPage = Loadable({ loader: () => import('./LandingPage') })
const LoadableInstagramLandingpage = Loadable({ loader: () => import('./InstagramLandingpage') })
const LoadableConfirmAccount = Loadable({ loader: () => import('./ConfirmAccount') })
const LoadableReisevorteil = Loadable({ loader: () => import('./Reisevorteil') })
const LoadableBonusBayLandingPage = Loadable({ loader: () => import('./BonusBayLandingPage') })

LoadableHome.preload()

@withRouter
@inject('translationStore', 'categoriesStore', 'favoritesStore')
@observer
export default class App extends React.Component {

  componentWillMount() {
    this.props.history.listen((location) => {
      if (window.ga) {
        window.ga('send', 'pageview', location.pathname)
      }
    });

    window.addEventListener('CookiebotOnConsentReady', function () {
      const cookieBot = cookie.load('CookieConsent')
      if (config.googleAnalyticsId && cookieBot && cookieBot.includes('statistics:true')) {
        // eslint-disable-next-line
        (function (i, s, o, g, r, a, m) {
          i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
            // eslint-disable-next-line
            (i[r].q = i[r].q || []).push(arguments)
          }, i[r].l = 1 * new Date(); a = s.createElement(o),
            // eslint-disable-next-line
            m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
        })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga')

        window.ga('create', config.googleAnalyticsId, 'auto')
        window.ga('send', 'pageview', window.location.pathname)
      } else {
        cookie.remove('_gat', { path: '/' })
        cookie.remove('_gid', { path: '/' })
        cookie.remove('_ga', { path: '/' })
        window.ga = undefined
      }
    });
  }

  render() {
    const { translationStore, categoriesStore, favoritesStore } = this.props

    return (
      <div className='AppContainer'>

        {translationStore.inProgress || categoriesStore.inProgress || favoritesStore.inProgress ?

          <LoadingOverlay active={true} background='white' spinner />
          :
          <div
            className='App'
          >
            <LoadableConfirmEmailBanner />
            {/* <LoadableGuidedIntroduction /> */}
            <LoadableError />
            <Header location={this.props.location} />
            <Switch>
              <Route path='/' exact component={LoadableHome} />
              <Route path='/faq' exact component={LoadableFAQ} />
              <Route path='/login' exact component={LoadableLogin} />
              <Route path='/login/easymillions' component={LoadableEasymillionsLoginTab} />
              <Route path='/registration' component={LoadableRegistration} />
              <Route path='/profile' exact component={LoadableProfile} />
              <Route path='/search' component={LoadableSearch} />
              <Route path='/page/:alias' exact component={LoadablePage} />
              <Route path='/wallet' exact component={LoadableWallet} />
              <Route path='/wallet/payoff' exact component={LoadablePayoff} />
              <Route path='/category/:category' exact component={LoadableCategory} />
              <Route path='/customer/confirm/:id' component={LoadableConfirmCustomer} />
              <Route path='/emailchange/confirmation/:id' exact component={LoadableChangeEmail} />

              <Route path='/account/confirm/:id' exact component={LoadableConfirmLead} />
              <Route path='/account/confirm/sms/:id' exact component={LoadableConfirmLead} />
              <Route path='/register/confirmation/:id' exact component={LoadableConfirmLead} />
              <Route path='/lead/confirm/:id' exact component={LoadableConfirmLead} />
              <Route path='/lead/confirm/sms/:id' exact component={LoadableConfirmLead} />
              <Route path='/confirm/:id' exact component={LoadableLandingPage} />
              <Route path='/confirm-account/:code' exact component={LoadableConfirmAccount} />

              <Route path='/contact' exact component={LoadableContact} />
              <Route path='/passwordrecover' exact component={LoadablePasswordRecover} />
              <Route path='/password-set/:id' exact component={LoadableChangePassword} />
              <Route path='/reactivate/:id' exact component={LoadableReactivate} />
              <Route path='/account/mail/unsubscribe/:email' exact component={LoadableUnsubscribeEmail} />
              <Route path='/insta' exact component={LoadableInstagramLandingpage} />

              <Route path='/reisevorteil' exact component={LoadableReisevorteil} />
              <Route path='/lpage' exact component={LoadableBonusBayLandingPage} />

              <Route path='/' component={LoadablePageNotFound} />
            </Switch>
            <Footer location={this.props.location} />
          </div>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/App.js